import { Box, Text, makeUclComponent } from '@rbilabs/universal-components';

import Currency from 'components/currency';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';

export {
  TransactionDate,
  TransactionDateAndTime,
  TransactionTime,
} from '../loyalty-history/loyalty-history.styled';

export const StyledCurrency = makeUclComponent(Currency).withConfig({
  isBold: false,
});

export const PurchaseAmount = Box.withConfig({
  flexDirection: 'row',
  justifyContent: 'flex-end',
});

export const Rewards = Box.withConfig({
  _text: {
    fontWeight: Styles.fontWeight.heavy,
  },
  flex: 1,
  paddingX: {
    md: '$10',
    base: '$1',
  },
});

export const Reward = Box.withConfig({
  _text: {
    fontSize: 'sm',
    color: Styles.color.black,
  },
});

export const StyledPointsIcon = LoyaltyPointsIcon.withConfig({
  width: '$4',
});

export const PointsText = Text.withConfig({
  fontSize: 'md',
  fontWeight: 'bold',
  marginLeft: '$1',
});

export const IconWrapper = Box.withConfig<{ $pointsEarned: boolean }>({
  flexDirection: 'row',
  alignItems: 'center',
});

export const PointsLineWrapper = Box.withConfig({
  flexDirection: 'column',
  width: 'full',
});

export const PointsDescription = Text.withConfig({
  fontSize: 'sm',
  fontWeight: 'normal',
  minWidth: '$32',
});
